import {PurchaseOrderItem, SourceMode, ToSourceItem} from "../../../../api/Logistics";
import {PhaseViewCol} from "../../../project/shopdrawing/openings/PhaseCol";
import {NumberCol, StringCol, Table, ViewOnly} from "../../../../misc/scroller/Table";
import {hasPermission, useUser} from "../../../../misc/Permission";
import {api} from "../../../../api/API";
import {ProjectCol, toSourceTableName} from "../PartsToSource";
import {CheckboxSelectorCol} from "../../../project/shopdrawing/Checkbox";
import {DistributionMode} from "../DistributionModeToggle";
import {useActionCol} from "./ActionCol";
import {getAll} from "../../routes/useGetAll";
import {DateFilterCol} from "../../../../misc/DateFilterForCol";

export function Door(props: {
    purchaseOrder?: number;
    supplier?: {
        id: number;
        name: string;
    }
    sourceMode: SourceMode,
    distributionMode: DistributionMode
    configureSourceGroup?: number;
    project?: number;
}) {
    const usr = useUser();

    const isRestock = props.sourceMode === "stock"
    const actionCol = useActionCol({
        purchaseOrder: props.purchaseOrder,
        configureSourceGroup: props.configureSourceGroup,
        sourceMode: props.sourceMode,
        update: (dt: Partial<PurchaseOrderItem>, input: ToSourceItem) => {
            return Object.assign({}, dt, {
                kind: "door",
            });
        }
    });

    return (
        <Table<ToSourceItem>
            name={toSourceTableName}
            overridePrefsName={toSourceTableName + ".door." + props.sourceMode}
            columns={[
                (props.purchaseOrder || props.configureSourceGroup) ? CheckboxSelectorCol({
                    disabled: row => !hasPermission(usr, "CanReleaseAndPurchase") && usr?.id === row.releasedBy,
                }) : null,
                !isRestock && ViewOnly(ProjectCol("Project", "projectName", "projectNumber", 100)),
                !isRestock && ViewOnly(StringCol("Opening", "openingName", 100)),
                !isRestock && ViewOnly(StringCol("Floor", "openingFloor", 70)),
                !isRestock && PhaseViewCol<ToSourceItem>("openingPhase", 70),
                DateFilterCol<ToSourceItem>("Due", "neededBy", "MMM D, YYYY", 100, "future"),
                ViewOnly(StringCol("Series", "doorSeries", 70)),
                ViewOnly(StringCol("Material", "doorMaterial", 100)),
                ViewOnly(StringCol("Finish", "doorFinish", 100)),
                ViewOnly(StringCol("Gauge", "doorGauge", 70)),
                ViewOnly(StringCol("Elev.", "doorElevation", 70)),
                ViewOnly(StringCol("Core", "doorCore", 70)),
                ViewOnly(StringCol("Seam", "doorSeam", 70)),
                ViewOnly(StringCol("Handing", "doorHanding", 70)),
                ViewOnly(StringCol("Label", "doorLabel", 120)),
                ViewOnly(StringCol("Nom. Width", "dimWidth", 70)),
                ViewOnly(StringCol("Nom. Height", "dimHeight", 70)),
                ViewOnly(NumberCol("Need", "qty", 60)),
                isRestock && ViewOnly(NumberCol("Stock", "stockQty", 60)),
                isRestock && ViewOnly(NumberCol("Rsrvd", "reservedQty", 60)),
                isRestock && ViewOnly(NumberCol("Pend.PO", "purchasedQty", 90)),
                isRestock && ViewOnly(NumberCol("Stock Min", "stockMinQty", 90)),
                isRestock && ViewOnly(NumberCol("Ideal Qty", "idealQty", 90)),
                actionCol,
            ]}
            fetch={ctx => getAll(ctx, offset => api.logistics.listToSourceItems({
                offset,
                supplier: props.supplier?.id,
                type: "door",
                sourceMode: props.sourceMode,
                distributionMode: props.distributionMode,
                project: props.project,
            }))}
            fetchDeps={[props.supplier, props.sourceMode, props.distributionMode, props.project]}
        />
    )
}

